import useSession from "./useSession";

export default function useCsrf() {
  const session = useSession();

  return session?.authenticity_token;
}
